<template>
    <AppModal :name="name" :onEnterKeyPress="disableTwoFactor" :beforeClose="beforeClose">
        <template v-slot:header>
            Remove Two-factor
        </template>
        <template v-slot:content>
            <div class="my-4 font-16">
                Are you sure you wish to remove two factor authentication from your account?
            </div>
            <p v-if="disableError" class="text-danger pt-4">
                Something went wrong
            </p>
        </template>
        <template v-slot:actions>
            <div class="row mx-0 justify-content-end">
                <button @click="$modal.hide(name)" class="btn btn-link mt-3 mr-3">Cancel</button>
                <button v-loading.btn="isLoading"
                        @click="disableTwoFactor"
                        class="btn btn-primary"
                        style="width: 195px">
                    Disable two-factor
                </button>
            </div>
        </template>
    </AppModal>
</template>

<script>
import AppModal from '../../../components/shared/AppModal'
import axios from 'axios'
import {USER_UPDATE} from '@/store/mutations'
import {mapGetters} from 'vuex'
import {showPlainErrorMessage, showSuccessMessage} from '@/services/snackbar'
import {withPasswordConfirmation} from '@/decorators/password-confirmation'

export default {
    name: 'RemoveTwoFactor',
    components: {AppModal},
    props: {
        name: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            isLoading: false,
            disableError: false
        }
    },
    computed: {
        ...mapGetters(['getUser'])
    },
    methods: {
        disableTwoFactor() {
            withPasswordConfirmation({
                onConfirm: this.disableTwoFactorProceed
            })
        },

        disableTwoFactorProceed(password) {
            this.isLoading = true
            return axios.post('/users/2fa/remove', {password})
                .then(() => {
                    this.$store.commit(USER_UPDATE, {hasTwoFactor: false})
                    showSuccessMessage('Two-factor disabled')
                    this.$modal.hide(this.name)
                })
                .catch(error => {
                    showPlainErrorMessage(error)
                    this.disableError = true
                })
                .finally(() => {
                    this.isLoading = false
                })
        },

        beforeClose() {
            this.disableError = false
        }
    }
}
</script>

<style scoped>
</style>
